import { createSlice } from '@reduxjs/toolkit'

export const curriculumUI = createSlice({
  name: 'curriculumUI',
  initialState: {
    unitBackUrl: null,
  },
  reducers: {
    setUnitBackUrl: (state, { payload }) => {
      state.unitBackUrl = payload
    },
  },
})

export const {
  setUnitBackUrl,
} = curriculumUI.actions

export default curriculumUI.reducer
